<div *ngIf="type === DocType.PDF || type === DocType.INVOICE" class="viewer">
  <ngx-extended-pdf-viewer
    height="100%"
    [src]="src"
    [showOpenFileButton]="false"
    [showPrintButton]="false"
    [showDownloadButton]="false"
    [showBookmarkButton]="false"
  ></ngx-extended-pdf-viewer>
</div>
<iframe
  *ngIf="type === DocType.VIDEO_LINK"
  [src]="src | safe : 'resourceUrl'"
  class="viewer"
></iframe>
<div
  *ngIf="type === DocType.HTML"
  class="viewer html-viewer scroll"
  [perfectScrollbar]="{ wheelPropagation: false }"
>
  <div [innerHtml]="src | safe : 'html'" style="min-height: 100% !important" class="bg-white"></div>
</div>
<div *ngIf="type === DocType.TIF || type === DocType.TIFF" class="d-flex flex-column h-100">
  <div style="height: 60px !important" class="row">
    <div class="col-4"></div>
    <div class="col-4 d-flex flex-center">
      <button
        matTooltip="First"
        class="btn btn-icon btn-sm btn-light mr-1"
        [disabled]="pageIndex === 0"
        (click)="changePage($event, 'FIRST')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-to-left.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <button
        matTooltip="Prev"
        class="btn btn-icon btn-sm btn-light mx-1"
        [disabled]="pageIndex === 0"
        (click)="changePage($event, 'PREV')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-left.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <div style="width: 60px !important" class="font-weight-bold text-center mx-1">
        {{ pageIndex + 1 }} OF {{ pages.length }}
      </div>
      <button
        matTooltip="Next"
        class="btn btn-icon btn-sm btn-light mx-1"
        [disabled]="pageIndex === pages.length - 1"
        (click)="changePage($event, 'NEXT')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-right.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <button
        matTooltip="Last"
        class="btn btn-icon btn-sm btn-light ml-1"
        [disabled]="pageIndex === pages.length - 1"
        (click)="changePage($event, 'LAST')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-to-right.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
    </div>
    <div class="col-4 d-flex align-items-center justify-content-end">
      <button
        matTooltip="Zoom Out"
        class="btn btn-icon btn-sm btn-light mr-1"
        (click)="zoom($event, 'OUT')"
      >
        <span
          inlineSVG="assets/media/svg/icons/General/zoom-out.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <button
        matTooltip="Zoom Fit"
        class="btn btn-icon btn-sm btn-light mx-1"
        (click)="zoom($event, 'FIT')"
      >
        <span
          inlineSVG="assets/media/svg/icons/General/zoom-fit.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <button
        matTooltip="Zoom In"
        class="btn btn-icon btn-sm btn-light ml-1"
        (click)="zoom($event, 'IN')"
      >
        <span
          inlineSVG="assets/media/svg/icons/General/zoom-in.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
    </div>
  </div>
  <div
    class="viewer tif-viewer flex-grow-1 scroll"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <div *ngIf="showErr | async" class="d-flex flex-center bg-white h-100">
      <span class="font-weight-bold">Oops! Something went wrong.</span>
    </div>
    <ng-container *ngIf="!(showErr | async)">
      <div *ngIf="loading | async" class="d-flex flex-center h-100">
        <mat-spinner color="primary" strokeWidth="5"></mat-spinner>
      </div>
      <img
        *ngIf="!(loading | async)"
        alt=""
        [style.width]="zoomScale * 100 + '%'"
        [src]="pages[pageIndex]"
      />
    </ng-container>
  </div>
</div>
